// extracted by mini-css-extract-plugin
export var component = "FooterMenu-module--component--5F+7+";
export var list = "FooterMenu-module--list--s8Wl3";